/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/arrow_up_medium'
export default icon
